import { render, staticRenderFns } from "./NewPropertyScreen.vue?vue&type=template&id=81e0a4bc&scoped=true"
import script from "./NewPropertyScreen.vue?vue&type=script&lang=js"
export * from "./NewPropertyScreen.vue?vue&type=script&lang=js"
import style0 from "./NewPropertyScreen.vue?vue&type=style&index=0&id=81e0a4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e0a4bc",
  null
  
)

export default component.exports